module.exports = __webpack_public_path__ + "img/1559340870.a26e7ae1.jpg";